import React, { useEffect, useState } from "react";
import {
    FaPalette,
    FaPen,
    FaCogs,
    FaChevronDown,
    FaChevronLeft,
    FaChevronRight,
    FaTh,
    FaSignOutAlt,
    FaHeadset,
    FaArrowRight,
    FaPhotoVideo,
    FaBarcode,
    FaFileInvoice,
    FaBullhorn,
    FaGlobe,
    FaPlusCircle,
    FaBalanceScale,
    FaStackOverflow,
    FaRegChartBar,
    FaUsers,
    FaShippingFast,
} from "react-icons/fa";
import { HiOutlinePlayCircle } from "react-icons/hi2";

// import SideBarItem from "./SideBarItem";
import { Link, useNavigate } from "react-router";
import { SlMenu } from "react-icons/sl";
import { TfiDashboard } from "react-icons/tfi";
import { AiOutlineDashboard, AiOutlineShop } from "react-icons/ai";
import { FiBox, FiPlusCircle } from "react-icons/fi";
import { LuCalculator, LuMessageCircleMore, LuPackageSearch, LuScale, LuTickets, LuWeight } from "react-icons/lu";
import { TbCash, TbCurrentLocation, TbTruckLoading } from "react-icons/tb";
import { GrLocation } from "react-icons/gr";
import { IoWalletOutline } from "react-icons/io5";
import { CgCloseR, CgProfile } from "react-icons/cg";
import { BsBox2, BsBoxes, BsCartPlusFill, BsCash, BsTruck } from "react-icons/bs";
import { MdConfirmationNumber, MdOndemandVideo, MdOnlinePrediction, MdOutlinePeopleAlt, MdOutlinePolicy, MdOutlineReport, MdOutlineSpaceBar, MdPayment, MdPhotoLibrary } from "react-icons/md";
import { FaTruckRampBox } from "react-icons/fa6";
import { toast } from "react-toastify";
import { HiOutlineAcademicCap, HiOutlineCalculator, HiOutlineDocumentDuplicate, HiOutlineDocumentText, HiOutlineGlobeAlt, HiOutlinePlusCircle, HiOutlineSpeakerphone } from "react-icons/hi";
import { PiFireTruck, PiFireTruckBold } from "react-icons/pi";
import { LiaTruckLoadingSolid } from "react-icons/lia";
import { RiLockPasswordLine, RiLogoutCircleRLine } from "react-icons/ri";
// import { SIGNOUT } from "../../graphql/Mutation/LoginRegisterFranchise";
// import { useMutation } from "@apollo/client";
import SideBarItemAdmin from "./SideBarItemAdmin.js";


export default function Sidebar({ collapsed, setCollapsed }) {
    const [openMenu, setOpenMenu] = useState("Forms");
    // const [signOut_Mutation] = useMutation(SIGNOUT);
    const registrationToken = localStorage.getItem("registrationToken");
    const navigate = useNavigate();

    // const signOut = async (client) => {
    //     if (registrationToken) {
    //         await signOut_Mutation({ variables: { webFcmToken: registrationToken } })
    //     }
    //     localStorage.clear();
    //     sessionStorage.clear();
    //     // client.resetStore(); // clears Apollo cache
    //     navigate("/"); // redirect to login or landing page
    //     toast.success("User logged out successfully!", { autoClose: 2000 });
    // };


    const menu = [
        {
            items: [
                {
                    icon: (
                        <FaRegChartBar
                            className="text-3xl text-blue-500 drop-shadow-lg hover:text-pink-500 transition duration-300"
                        />
                    ),
                    label: "Dashboard",
                    to: "/admindashboard",
                },
            ],
        },

        {
            title: "Customer Details",
            items: [
                {
                    icon: <FaUsers />,
                    label: "Customer Details",
                    children: [
                        {
                            icon: <FaShippingFast className="text-2xl text-pink-500" />,
                            label: "Today Shipment",
                            to: "/todayshipment",
                        },
                        {
                            icon: (
                                <MdConfirmationNumber className="text-2xl text-green-500 hover:text-emerald-600 drop-shadow-sm transition" />
                            ),
                            label: "Today Tickets",
                            to: "/todayticketsadmin",
                        },
                        {
                            icon: (
                                <FaUsers className="text-2xl text-blue-500 hover:text-cyan-400 drop-shadow-md transition" />
                            ),
                            label: "Customers",
                            to: "/admintotalcustomer",
                        },
                        {
                            icon: (
                                <IoWalletOutline className="text-2xl text-yellow-500 hover:text-orange-500 drop-shadow-md transition" />
                            ),
                            label: "Today Pickup Shipment",
                            to: "/openPendingPickupOrder",
                        },
                        {
                            icon: <BsCartPlusFill className="text-2xl text-red-500" />,
                            label: "New Customers Order",
                            to: "/newcustomersorderadmin",
                        },
                        {
                            icon: <BsCartPlusFill className="text-2xl text-red-500" />,
                            label: "Total Costomer ",
                            to: "/totalcostomeradmin",
                        },
                        {
                            icon: <BsCartPlusFill className="text-2xl text-red-500" />,
                            label: "Online Order ",
                            to: "/onlineorderadmin",
                        },

                    ]
                }
            ],
        },


        {
            title: "Franchise Details",
            items: [
                {
                    icon: <FaUsers />,
                    label: "Franchise Details",
                    children: [
                        {
                            icon: <FaShippingFast className="text-2xl text-pink-500" />,
                            label: "Today Shipment",
                            to: "/todayshipmentfranchiseorder",
                        },
                        {
                            icon: (
                                <MdConfirmationNumber className="text-2xl text-green-500 hover:text-emerald-600 drop-shadow-sm transition" />
                            ),
                            label: "Today Tickets",
                            to: "/adminticket",
                        },
                        {
                            icon: (
                                <FaUsers className="text-2xl text-blue-500 hover:text-cyan-400 drop-shadow-md transition" />
                            ),
                            label: "Customers",
                            to: "/",
                        },
                        {
                            icon: (
                                <IoWalletOutline className="text-2xl text-yellow-500 hover:text-orange-500 drop-shadow-md transition" />
                            ),
                            label: "Today Pickup Shipment",
                            to: "/openPendingPickupOrder",
                        },
                        {
                            icon: <BsCartPlusFill className="text-2xl text-red-500" />,
                            label: "New Customers Order",
                            to: "/newcustomersorderfranchisedetails",
                        },
                        {
                            icon: <BsCartPlusFill className="text-2xl text-red-500" />,
                            label: "International Courier",
                            to: "/internationalcourierbyfranchise",
                        },
                        {
                            icon: <BsCartPlusFill className="text-2xl text-red-500" />,
                            label: "Total Franchise",
                            to: "/totalfranchiseadmin",
                        },
                        {
                            icon: <BsCartPlusFill className="text-2xl text-red-500" />,
                            label: "Weight Mismatch",
                            to: "/weightmismatchbyfranchise",
                        },
                        {
                            icon: <BsCartPlusFill className="text-2xl text-red-500" />,
                            label: "Fetch AWB Numbers",
                            to: "/fetchawbnumbersbyfranchise",
                        },
                        {
                            icon: <BsCartPlusFill className="text-2xl text-red-500" />,
                            label: "Franchise Enquiry",
                            to: "/adminfranchiseenquiry",
                        },

                    ]
                }
            ],
        },


        {
            title: " Payment ",
            items: [
                {
                    icon: <FaUsers />,
                    label: " Payment",
                    children: [
                        {
                            icon: <FaShippingFast className="text-2xl text-pink-500" />,
                            label: "Cod Seller Payment",
                            to: "/adminCodSellerPayment",
                        },
                        {
                            icon: (
                                <MdConfirmationNumber className="text-2xl text-green-500 hover:text-emerald-600 drop-shadow-sm transition" />
                            ),
                            label: "ReFund Payment",
                            to: "/adminrefund",
                        },


                    ]
                }
            ],
        },


        {
            title: " Complaint both  ",
            items: [
                {
                    icon: <FaUsers />,
                    label: " Complaint ",
                    children: [
                        {
                            icon: <FaShippingFast className="text-2xl text-pink-500" />,
                            label: "Franchise Complaint ",
                            to: "/franchisecomplaintadmin",
                        },
                        {
                            icon: (
                                <MdConfirmationNumber className="text-2xl text-green-500 hover:text-emerald-600 drop-shadow-sm transition" />
                            ),
                            label: "Costomers Complaint",
                            to: "/costomerscomplaintadmin",
                        },


                    ]
                }
            ],
        },

        {
            title: "Movement  ",
            items: [
                {
                    icon: <FaUsers />,
                    label: " In Movement ",
                    children: [
                        {
                            icon: <FaShippingFast className="text-2xl text-pink-500" />,
                            label: "All Movement ",
                            to: "/allmovement",
                        },




                    ]
                }
            ],
        },

        {
            title: " Pickup-Delivery Executive   ",
            items: [
                {
                    icon: <FaUsers />,
                    label: " Pickup-Delivery Executive ",
                    children: [
                        {
                            icon: <FaShippingFast className="text-2xl text-pink-500" />,
                            label: "Delivery Executive  ",
                            to: "/deliveryexecutivesdmin",
                        },

                        {
                            icon: <FaShippingFast className="text-2xl text-pink-500" />,
                            label: "Pickup Executive  ",
                            to: "/pickupexecutiveadmin",
                        },


                    ]
                }
            ],
        },
        {
            title: " Wallet ",
            items: [
                {
                    icon: <FaUsers />,
                    label: "Wallet & Utilities ",
                    children: [
                        {
                            icon: <FaShippingFast className="text-2xl text-pink-500" />,
                            label: "Franchise Wallet",
                            to: "/walletshowfranchiseadmin",
                        },

                        // {
                        //     icon: <FaShippingFast className="text-2xl text-pink-500" />,
                        //     label: "Pickup Executive  ",
                        //     to: "/",
                        // },


                    ]
                }
            ],
        },

        {
            title: " Social Advertisement ",
            items: [
                {
                    icon: <FaUsers />,
                    label: "Advertisement ",
                    children: [
                        {
                            icon: <FaShippingFast className="text-2xl text-pink-500" />,
                            label: "Advertisement Franchise",
                            to: "/advertisementadmin",
                        },

                        // {
                        //     icon: <FaShippingFast className="text-2xl text-pink-500" />,
                        //     label: "Pickup Executive  ",
                        //     to: "/",
                        // },


                    ]
                }
            ],
        },

        {
            title: " ADD Franchise & RO ",
            items: [
                {
                    icon: <FaUsers />,
                    label: "Franchise Added ",
                    children: [
                        {
                            icon: <FaShippingFast className="text-2xl text-pink-500" />,
                            label: "Franchise Added",
                            to: "/franchiseadded",
                        },

                        // {
                        //     icon: <FaShippingFast className="text-2xl text-pink-500" />,
                        //     label: "Pickup Executive  ",
                        //     to: "/",
                        // },


                    ]
                }
            ],
        },

        // {
        //     title: "International Shipment",
        //     items: [
        //         {
        //             icon: <HiOutlineGlobeAlt className="text-xl" />,   // 🌍 Outline globe for International
        //             label: "International Shipment",
        //             children: [
        //                 {
        //                     icon: <HiOutlinePlusCircle className="text-xl" />, // ➕ Outline for Create Order
        //                     label: "Create Intl. Shipment",
        //                     to: "/globalcreateorder",
        //                 },
        //                 {
        //                     icon: <HiOutlineDocumentText className="text-xl" />, // 📄 Outline document for Orders
        //                     label: "All Intl. Shipment",
        //                     to: "/globalallorders",
        //                 },
        //                 {
        //                     icon: <LuScale className="text-xl" />, // ⚖️ Outline scale for Calculator
        //                     label: "Intl. Shipment Calculator",
        //                     to: "/globalshipmentalcutator",
        //                 },
        //                 {
        //                     icon: <LuPackageSearch className="text-xl" />, // ⚖️ Outline scale for Calculator
        //                     label: "Intl. Tracking",
        //                     to: "/trackcourier",
        //                 },
        //             ],
        //         },
        //     ],
        // },
        // {
        //     title: "Wallet & Utilities",
        //     items: [
        //         {
        //             icon: <LuTickets className="text-xl" />,   // 🎓 Academy / learning
        //             label: "Wallet & Utilities",
        //             children: [
        //                 {
        //                     icon: <IoWalletOutline className="text-xl" />,
        //                     label: " Wallet Transactions",
        //                     to: "/wallettransactions",
        //                 },



        //                 {
        //                     icon: <BsBox2 className="text-" />,
        //                     label: "Shipping Charge",
        //                     to: "/shippingcharge",
        //                 },

        //                 {

        //                     icon: <HiOutlineCalculator className="text-xl" />,
        //                     label: "Rate Calculator",
        //                     to: "/ratecalculator",
        //                 },

        //                 {
        //                     icon: <HiOutlineDocumentDuplicate className="text-xl" />, // 📄 Documents / AWB
        //                     label: "Fetch AWB Numbers",
        //                     to: "/fetchawbnumbers",
        //                 },
        //                 {
        //                     icon: <HiOutlineSpeakerphone className="text-xl" />, // 📢 Advertisement / promotion
        //                     label: "Social Advertisement",
        //                     to: "/socialadvertisement",
        //                 },
        //                 {
        //                     icon: <HiOutlinePlayCircle className="text-xl" />, // ▶️ Tutorials / videos
        //                     label: "Panel Tutorials",
        //                     to: "/paneltutorials",
        //                 },
        //             ],
        //         },
        //     ],
        // },



        // {
        //     title: "Seller Profile",
        //     items: [


        //         {
        //             icon: <AiOutlineShop className="text-xl" />,
        //             label: "Seller Profile",
        //             to: "/sellerprofiledetails",
        //         },


        //     ],
        // },


        // {
        //     title: "Pickup-Delivery Executive",
        //     items: [


        //         {
        //             icon: <MdOutlinePeopleAlt className="text-xl" />,
        //             label: "Pickup-Delivery Executive",
        //             to: "/pickupdeliveryexecutive",
        //         },


        //     ],

        // },
        {
            title: "Hub Manager Information",
            items: [
                {
                    icon: <CgProfile className="text-3xl text-indigo-500 drop-shadow-md" />,

                    label: "Hub Manager Details",
                    children: [
                        {
                            label: "Hub Manager Information",
                            to: "/personalinformationmanagerhub",
                            icon: (
                                <MdPhotoLibrary className="text-xl text-pink-500 hover:text-purple-500 drop-shadow-sm transition" />
                            ),
                        },
                        {
                            icon: <FaShippingFast className="text-2xl text-pink-500" />,
                            label: "Manager Infomation ",
                            to: "/ManagerInfoTable",
                        },



                    ],
                },
            ],
        },


        {
            title: "Setting",
            items: [
                {
                    icon: <CgProfile className="text-3xl text-indigo-500 drop-shadow-md" />,

                    label: "WebSite Setting",
                    children: [
                        {
                            label: "Carousel",
                            to: "/carousel",
                            icon: (
                                <MdPhotoLibrary className="text-xl text-pink-500 hover:text-purple-500 drop-shadow-sm transition" />
                            ),
                        },
                        {
                            label: "Advertisement",
                            to: "/adminad",
                            icon: (
                                <FaBullhorn className="text-xl text-green-500 hover:text-emerald-600 drop-shadow-sm transition" />
                            ),
                        },
                        {
                            label: "Edit Privacy Policy",
                            to: "/adminpolicy",
                            icon: (
                                <MdOutlinePolicy className="text-xl text-blue-500 hover:text-cyan-400 drop-shadow-md transition" />
                            ),
                        },
                        {
                            label: "Edit topbar",
                            to: "/admintopbar",
                            icon: (
                                <MdOutlineSpaceBar className="text-xl text-orange-500 hover:text-red-500 drop-shadow-md transition" />
                            ),
                        },
                        {
                            // icon: <FaSignOutAlt className="text-xl" />,
                            label: "Log out",
                            isLogout: true, // add a flag
                            icon: (
                                <RiLogoutCircleRLine className="text-xl text-red-500 hover:text-red-700 drop-shadow-lg transition" />
                            ),
                        },
                    ],
                },
            ],
        },

    ];

    return (
        <>
            {/* Overlay on small screens */}
            <div
                className={`fixed inset-0 bg-black  bg-opacity-40 z-30 md:hidden transition-opacity duration-300 ${collapsed ? "opacity-0 pointer-events-none" : "opacity-100"}`}
                onClick={() => setCollapsed(true)}
            ></div>

            <div
                className={`
    fixed top-0 left-0 z-40 h-full bg-white overflow-y-auto text-black shadow-md transition-transform duration-300
    ${collapsed ? "w-26" : "w-52"}  ${collapsed ? "-translate-x-full" : "translate-x-0"}
    lg:relative lg:translate-x-0 
  `}

            >
                {/* Header */}
                <div className="flex items-center justify-between px-4 py-4 border-b border-gray-700">
                    {!collapsed && <span className="text-lg font-bold">AlgarXpress</span>}
                    <button onClick={() => {
                        if (window.innerWidth < 768) {
                            // On small screens: always collapse
                            setCollapsed(true);
                        } else {
                            // Toggle on large screens
                            setCollapsed(!collapsed);
                        }
                    }} className="text-xl text-black" >

                        {collapsed ? (
                            <>
                                <img
                                    // src="/heart-svgrepo-com (1) 27-Photoroom.png"
                                    className="h-9"
                                    alt=""
                                />
                                <SlMenu className="ml-1 mt-6" />
                            </>
                        ) : (
                            <SlMenu />
                        )}
                    </button>
                </div>

                {/* Menu */}
                <div className="p-2">
                    {menu.map((section, idx) => (
                        <div key={idx} className="mb-1">
                            {!collapsed && section.title && (
                                <h2 className="text-xs text-black mb-2 font-bold">{section.title}</h2>
                            )}
                            {section.items.map((item, i) => (
                                <SideBarItemAdmin
                                    key={i}
                                    item={item}
                                    collapsed={collapsed}
                                    isOpen={openMenu === item.label}
                                    onToggle={() =>
                                        setOpenMenu(openMenu === item.label ? "" : item.label)
                                    }
                                // signOut={signOut}
                                />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}


